module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAAQlBMVEUAAACYeQCuiwDCmwDEnQDWAADWqwDYrQDquwDsAADsvAD+ywD/AAD/zQD/2QD/3AD/4AD/6gD/7wD/+wD//gD//wD0fg8fAAAAMklEQVR42mOgJuBBA5ys5AuJigigAC42BmEhVCF2ZgZBfl4uJMDOwsTAx83BhgSYmRgBB+EGgptpXQMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag/germany.png
// module id = 5d6Y
// module chunks = 1